import { render, staticRenderFns } from "./mode-of-procurement.vue?vue&type=template&id=38c8a831&"
import script from "./mode-of-procurement.vue?vue&type=script&lang=js&"
export * from "./mode-of-procurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports